export class KreditlinieVhvKautionEntry {

    buergschaftsLinie = 0;
    einzellimit = 0;
    hoechstBetragPercent = 0;
    jahresBeitrag = 0;

}
